import React, { memo } from 'react';
import reactDom from 'react-dom';

import { I18nProvider } from '@olxeu-a2b/ui/src/i18n';
import { ThemeProvider } from '@olxeu-a2b/ui/src/theme';
import { useViewport } from '@olxeu-a2b/delivery-utils/src/hooks';

import LQProvider from '@olx/react-laquesis/Provider';
import { getLQExperimentsAndFeatureFlags } from "@olxeu-a2b/delivery-utils/src/extras/lqUtils";

import '@nexus/lib-react/dist/theme/CoreTheme/style.css';

import { setup as ninjaSetup } from '@olxeu-a2b/delivery-utils/src/tracking/ninja-utils';
import { setup as sentrySetup } from './tracking/sentry';
import hotjarSetup from './externalLibs/hotjar/setup';

import ViewportContext from './contexts/ViewportContext';

import { TemplateProvider } from './contexts/TemplateContext';
import { RoutesProvider } from './routes/RoutesContext';
import ContextualTemplate from './commons/components/ContextualTemplate';

import './styles/index.scss';

ninjaSetup();
sentrySetup();
hotjarSetup();

const { lqCookie, lqFeatureFlagCookie } = getLQExperimentsAndFeatureFlags();

const App = memo(() => {
  const viewport = useViewport();

  return (
    <ThemeProvider>
      <ViewportContext.Provider value={viewport}>
        <I18nProvider>
          <RoutesProvider>
            <TemplateProvider>
              <ContextualTemplate />
            </TemplateProvider>
          </RoutesProvider>
        </I18nProvider>
      </ViewportContext.Provider>
    </ThemeProvider>
  );
});

const appEl = document.getElementById('app');
appEl.innerHTML = null;
reactDom.render(
  <LQProvider cookie={lqCookie} cookieff={lqFeatureFlagCookie}>
    <App />
  </LQProvider>,
  appEl,
);

export default App;
